import api, { headers, STUDENT_API } from "./api";
import { ADMIN_API, TEACHER_API, UPLOAD } from "./api";

export const ADMIN = async () => {
  return await api.get(ADMIN_API, { headers });
};

// Teacher Apis
export const getTeachers = async () => {
  return await api.get(TEACHER_API, { headers });
};

export const signIn = async (body) => {
  return await api.post(`/auth/signin`, body);
};

export const getTeacherDetails = async (teacherId) => {
  const response = await api.get(
    `/teachers/${teacherId}/getTeacherAllData`,
    {
      headers,
    }
  );
  return response;
};

export const warningTeacher = async (teacherId, body) => {
  return await api.post(`/teachers/${teacherId}/warning`, body);
};

export const toggleBlockTeacher = async (teacherId, isBlocked) => {
  const requestBody = { isBlocked: isBlocked };
  return await api.put(
    `/teachers/${teacherId}/toggleBlock`,
    requestBody,
    { headers }
  );
};

export const approvedTeacher = async (teacherId, isApproved) => {
  const requestBody = { approved: isApproved };
  return await api.put(
    `/teachers/${teacherId}/approve`,
    requestBody,
    { headers }
  );
};

export const teacherReviews = async (teacherId) => {
  return await api.get(`/teachers/${teacherId}/reviews`);
};

export const getWarningTeachersListing = async () => {
  return await api.get(`/teachers/warnings`);
};

export const getWarningTeachersContent = async (teacherId) => {
  return await api.get(`/teachers/${teacherId}/warnings`);
};

// Student APIs
export const getStudents = async () => {
  return await api.get(STUDENT_API, { headers });
};

export const getStudentDetails = async (studentId) => {
  const response = await api.get(`/students/${studentId}/details`, {
    headers,
  });
  return response;
};

export const warningStudent = async (studentId, body) => {
  return await api.post(`/students/${studentId}/warning`, body);
};

export const toggleBlockStudent = async (studentId, isBlocked) => {
  const requestBody = { isBlocked: isBlocked };
  return await api.put(
    `/students/${studentId}/toggleBlock`,
    requestBody,
    { headers }
  );
};

export const getWarningStudentsListing = async () => {
  return await api.get(`/students/warnings`);
};

export const getWarningStudentsContent = async (studentId) => {
  return await api.get(`/students/${studentId}/warnings`);
};

export const getAllCountires = async () => {
  return await api.get(`/countries`);
};

export const getAllProvinces = async () => {
  return await api.get(`/provinces`);
};

export const getAllCities = async () => {
  return await api.get(`/cities`);
};

export const getAllAreas = async (id) => {
  return await api.get(`/cities/${id}/areas`);
};

// Upload ProfileSetting Image
export const uploadFile = async (formData) => {
  return await api.post(UPLOAD, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Classes Api
export const getOfferSlotsByDatePastAndUpcoming = async (date) => {
  return await api.get(`/offerslots/date/${date}`);
};

export const getOfferSlotsByDateClosed = async (date) => {
  return await api.get(`/offerslots/date/${date}/closed`);
};

export const getOfferSlotsByDateDisputed = async (date) => {
  return await api.get(`/offerslots/date/${date}/disputed`);
};

export const disputeOfferSlot = async (body, offerSlotId) => {
  return await api.put(`/offerslots/${offerSlotId}`, body, {
    headers,
  });
};
